import { useState, useEffect, useCallback } from "react";
import type { Skill } from "@cowork/shared";

const ENGINE_URL = "http://localhost:3001";

export function useSkills(engineConnected = false) {
  const [skills, setSkills] = useState<readonly Skill[]>([]);

  const fetchSkills = useCallback(() => {
    fetch(`${ENGINE_URL}/skills`)
      .then((r) => r.json())
      .then((data: unknown) => {
        if (Array.isArray(data)) setSkills(data as Skill[]);
      })
      .catch(() => undefined);
  }, []);

  // Fetch on mount
  useEffect(() => { fetchSkills(); }, [fetchSkills]);

  // Re-fetch whenever the engine (re)connects
  useEffect(() => {
    if (engineConnected) fetchSkills();
  }, [engineConnected, fetchSkills]);

  return skills;
}
